import * as React from 'react';
import type { BrandVariants, GriffelRenderer, Theme } from '@fluentui/react-components';
import {
  // createDarkTheme,
  createDOMRenderer,
  createLightTheme,
  FluentProvider as BaseFluentProvider,
  RendererProvider,
} from '@fluentui/react-components';

export const brandRamp: BrandVariants = {
  10: '#000000',
  20: '#171022',
  30: '#261A3E',
  40: '#36235D',
  50: '#452C7D',
  60: '#55359F',
  70: '#663FC2',
  80: '#7749E7',
  90: '#8957FF',
  100: '#9B6CFF',
  110: '#AC81FF',
  120: '#BC96FF',
  130: '#CBABFF',
  140: '#D8C0FF',
  150: '#E6D5FF',
  160: '#F3EAFF',
};

export const theme: Theme = {
  ...createLightTheme(brandRamp),
  colorBrandBackground: brandRamp[60],
  colorBrandBackgroundHover: brandRamp[80],
};

// for when we need it. colors customized for accessibility
// const darkTheme: Theme = {
//   ...createDarkTheme(brandRamp),
//   colorBrandForeground1: brandRamp[110],
//   colorBrandForegroundLink: brandRamp[110],
//   colorBrandForegroundLinkPressed: brandRamp[120],
//   colorBrandForegroundLinkSelected: brandRamp[110],
//   colorCompoundBrandBackgroundHover: brandRamp[90],
// };

export function FluentProvider({ children, renderer }: { children: React.ReactNode; renderer?: GriffelRenderer }) {
  return (
    <RendererProvider renderer={renderer || createDOMRenderer(window.document)}>
      <BaseFluentProvider theme={theme}>{children}</BaseFluentProvider>
    </RendererProvider>
  );
}
